export default __webpack_public_path__ + "static/media/hp-plans-plan3.7a16c7d3.svg";